import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.component";

const rootElement = document.getElementById("__root");
const root = createRoot(rootElement);
root.render(<App />);
